import { Component, OnInit, OnDestroy, ViewChild, Optional, Inject, ChangeDetectorRef, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@app/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable, of } from 'rxjs';
import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { IAccountSettings } from '@app/core/interfaces/user/IAccountSettings';
import { UserService } from '@app/core/services/UserService';
import { MunicipalityService } from '@app/core/services/municipalityService';
import { IUser } from '@app/core/interfaces/user/IUser';
import { ICountryType } from '@app/core/interfaces/ICountryType';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Overlay } from '@angular/cdk/overlay';
import { ITaxAdjustment } from '@app/core/interfaces/user/ITaxAdjustment';
import { IAttachmentOfSalary } from '@app/core/interfaces/user/IAttachmentOfSalary';
import { EditTaxAdjustmentDialogComponent } from '../../../settings/settings/tax-adjustment/edit-tax-adjustment-Dialog.Component';
import { IFile } from '@app/core/interfaces/IFile';
import { IFileType } from '@app/core/interfaces/IFileType';
import { AttachmentOfSalaryDialogComponent } from '../../../settings/settings/attachment-of-salary/attachment-of-salary-Dialog.Component';
import { IBank } from '@app/core/interfaces/economy/IBank';
import { BankService } from '@app/core/services/BankService';
import { FileService } from '@app/core/services/FileService';
import { SwedishBankAccountValidationService } from '@app/core/services/SwedishBankAccountValidationService';



@Component({
  standalone: false,
    selector: 'anms-todos',
    templateUrl: './user-edit.component.html',
    styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit, OnDestroy {

    private unsubscribe$: Subject<void> = new Subject<void>();
    routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
    private userId: string;
    user: IUser;
    isLoading: boolean = true;
    selectedWorkRoles: any = [];
    countries = [];
    selectedTeams: any = [];
    selectedProjects: any = [];
    teams: any;
    projects: any;
    yesNo = [{ Name: "Ja", Value: true }, { Name: "Nej", Value: false }];
    newCourse = { External: false, GradeCertificate: {} };
    public selectedRoles = [];
    overview: any;
    municipalities: any;
    @ViewChild('taxAdjustmentsTable', { static: false }) taxAdjustmentsTable: MatTable<ITaxAdjustment>;
    @ViewChild('attachmentsTable', { static: false }) attachmentsTable: MatTable<IAttachmentOfSalary>;
    public isAdmin: boolean = false;
    public dataSourceTaxAdjustments: MatTableDataSource<ITaxAdjustment> = new MatTableDataSource<ITaxAdjustment>([]);
    public dataSourceAttachmentOfSalary: MatTableDataSource<IAttachmentOfSalary> = new MatTableDataSource<IAttachmentOfSalary>([]);
    public displayedColumnsTaxAdjustments;
    public displayedColumnsAttachmentsOfSalary;
    validationErrorMessage: string;
    bankValidationMessage: string = '';
    bankEntryMode: 'swedish' | 'personkonto' | 'international' = 'swedish';
    CustomServiceFee: number = 0;
    Commission: number = 0;
    selectedNotificationTypes = [];
    public banks: IBank[];
    updatedEmail: boolean = false;
    pendingMunicipality: string = "";
    referredByName: string = null;
    payoutTypes = [{ id: 1, name: 'Löpande' }, { id: 2, name: 'Fast datum varje månad' }];
    ReferredCode: string = null;
    isDialog: boolean = false;



    constructor(public store: Store<any>,
        public snackBar: MatSnackBar,
        private router: Router,
        private municipalityService: MunicipalityService,
        private userService: UserService,
        private route: ActivatedRoute,
        private bankService: BankService,
        private fileService: FileService,
        private swedishBankAccountValidationService: SwedishBankAccountValidationService,
        public dialog: MatDialog,
        private overlay: Overlay,
        private changeDetectorRef: ChangeDetectorRef,
        @Optional() public dialogRef: MatDialogRef<UserEditComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any) {
    }

  ngOnInit() {      
    if (this.dialogData && this.dialogData.userId) {
      this.isDialog = true;
      this.userId = this.dialogData.userId;
      this.config.data.userId = this.userId;
      this.loadUser(this.userId);
      this.loadMunicipalities();
      this.getCountries();
      this.isAdmin = this.userService.userHasRole("admin");
      this.setTableColumns(this.isAdmin);
      this.getBanks();
      return;
    }

    this.route.params.subscribe(params => {
      this.userId = params['id'];
      this.config.data.userId = this.userId;
      this.loadUser(this.userId);
      this.loadMunicipalities();
      this.getCountries();
      this.isAdmin = this.userService.userHasRole("admin");
      this.setTableColumns(this.isAdmin);
      this.getBanks();

    });
  }

  getBanks() {
    this.bankService.getAll()
      .subscribe(response => {
        this.banks = response;
        this.syncResolvedBankFromAccountDetails();
      }, err => alert(err));
  }

  resetModel() {
    this.user.Bank.Id = null; // Reset the ngModel value to null or any default value you want
  }

  onBankEntryModeChange(mode: 'swedish' | 'personkonto' | 'international') {
    this.bankEntryMode = mode;
    if (mode === 'international') {
      this.bankOnChange(2);
      return;
    }

    this.user.Bic = '';
    this.user.Iban = '';
    if (mode === 'personkonto') {
      this.user.ClearingNumber = '';
      this.user.AccountNumber = this.getNordeaPersonkontoAccountNumber();
      this.bankOnChange(5);
      return;
    }

    if (this.user.Bank?.IsInternational || this.user.Bank?.Id === 5) {
      this.user.Bank = { ...this.user.Bank, Id: 0, Name: 'Välj bank', IsInternational: false };
      this.user.BankName = '';
    }
    this.syncResolvedBankFromAccountDetails();
  }

  onPersonalNumberChange(value: string) {
    this.user.PersonalNumber = value;
    if (this.bankEntryMode === 'personkonto') {
      this.user.AccountNumber = this.getNordeaPersonkontoAccountNumber();
      this.syncResolvedBankFromAccountDetails();
    }
  }

  private getNordeaPersonkontoAccountNumber(): string {
    const digits = (this.user?.PersonalNumber || '').replace(/\D+/g, '');
    return digits.length < 10 ? '' : digits.slice(-10);
  }

  bankOnChange(bankId) {
    if (bankId === 2) {
      this.user.Bank = JSON.parse(JSON.stringify(this.banks.find((bank) => bank.Id === bankId)));
      this.user.BankName = this.user.Bank?.Name || '';
      this.syncResolvedBankFromAccountDetails();
      return;
    }

    for (var i = 0; i < this.banks.length; i++) {
      if (this.banks[i].Id == bankId) {
        this.user.Bank = JSON.parse(JSON.stringify(this.banks[i]));
        this.user.BankName = this.user.Bank?.Name || '';
      }
    }
    this.syncResolvedBankFromAccountDetails();
  }

  onClearingNumberChange(value: string) {
    this.user.ClearingNumber = value;
    this.syncResolvedBankFromAccountDetails();
  }

  onAccountNumberChange(value: string) {
    this.user.AccountNumber = value;
    this.syncResolvedBankFromAccountDetails();
  }

  private syncResolvedBankFromAccountDetails() {
    if (this.bankValidationMessage && this.validationErrorMessage === this.bankValidationMessage) {
      this.validationErrorMessage = '';
    }
    this.bankValidationMessage = '';
    if (!this.user || !this.banks || this.banks.length === 0) {
      return;
    }

    if (this.user.Bank?.IsInternational) {
      return;
    }

    if ((!this.user.ClearingNumber || this.user.ClearingNumber === '') && (!this.user.AccountNumber || this.user.AccountNumber === '')) {
      return;
    }

    const result = this.swedishBankAccountValidationService.validate(
      this.banks,
      this.user.ClearingNumber,
      this.user.AccountNumber,
      this.user.PersonalNumber
    );

    this.bankValidationMessage = result.isValid ? '' : result.message;
    this.user.BankName = result.resolvedBankName || '';

    if (result.resolvedBank) {
      this.user.Bank = JSON.parse(JSON.stringify(result.resolvedBank));
      this.user.ClearingNumber = result.normalizedClearingNumber;
      this.user.AccountNumber = result.normalizedAccountNumber;
      return;
    }

    if (this.user.Bank && !this.user.Bank.IsInternational) {
      this.user.Bank.Id = 0;
      this.user.Bank.Name = 'Välj bank';
    }
  }

  setTableColumns(isAdmin: boolean) {
    if (isAdmin) {
      this.displayedColumnsTaxAdjustments = ['type', 'startdate', 'enddate', 'maxamount', 'temptax', 'tempemptax', 'approved', 'attachment', 'admin'];
    }
    else {
        this.displayedColumnsTaxAdjustments = ['type', 'startdate', 'enddate', 'attachment'];
    }

    this.displayedColumnsAttachmentsOfSalary = ['startdate', 'enddate', 'reservedamount', 'attachmentamount', 'attachment', 'admin']
      
  }

  loadUser(userid: string) {
      this.userService.getUser(userid)
          .subscribe(value => this.userLoaded(value),
          error => console.log(error)
          );
  }

  loadMunicipalities() {
      this.municipalityService.getMunicipalities()
          .subscribe(value => this.municipalities = value,
          error => console.log(error)
    );
  }

  municipalityChange(municipalityId: any) {

      for (var i = 0; i < this.municipalities.length; i++) {
          if (this.municipalities[i].Id == municipalityId) {
              this.user.Municipality.Tax = this.municipalities[i].Tax;
          }
      }

  }

  getCountries() {
    this.userService.getCountries()
      .subscribe(value => this.countries = value,
        error => this.onError(error)
      );
  }

  onError(error: any) {
    alert('An error occured');
    console.log(error);
  }

  getCountryName(countryId: number) {
    for (var i = 0; i < this.countries.length; i++) {
      if (this.countries[i].Id == countryId) {

        this.user.Country.Name = this.countries[i].Name;
        this.user.Country.Eu = this.countries[i].Eu;
      }
    }
  }

  setSelectedNotificationSettings() {

    var selectedNotifications = [];
    
    // Loop all settings
    for (var i = 0; i < this.user.NotificationSettings.length; i++) {
      var setting = this.user.NotificationSettings[i];
      
      // Loop selected setting
      if (setting.Active) {
        this.selectedNotificationTypes.push(setting.Type.Id);
      }
    }    
  }

  notificationSettingsChange(selectedItems) {
    
    // Loop all settings
    for (var i = 0; i < this.user.NotificationSettings.length; i++) {
      var setting = this.user.NotificationSettings[i];
      // Loop selected setting
      setting.Active = false;

      for (var e = 0; e < selectedItems.length; e++) {
        var currentSettingId = selectedItems[e];
        if (currentSettingId == setting.Type.Id)
          setting.Active = true; // Selected
      }
    }
  }

  userReloaded(user: any) {
      //this.dataSource = user.Enrollments
      this.refreshTaxAdjustmentsTable();
      this.refreshAttachmentsTable();
  }
    
  overviewLoaded(overview: any) {
      this.isLoading = false;
      this.overview = overview;
  }
    
  userLoaded(user: IUser) {
    
    this.user = user;
    this.bankEntryMode = user.Bank?.IsInternational ? 'international' : (user.Bank?.Id === 5 ? 'personkonto' : 'swedish');
    this.user.Country = this.user.Country || {} as ICountryType;
    this.user.TaxAdjustments = this.user.TaxAdjustments || [];
    this.user.AttachmentOfSalaries = this.user.AttachmentOfSalaries || [];

    if (user.Email.includes("tmpe@tmpemail.com")) {
      this.updatedEmail = false;
    }
    else {
      this.updatedEmail = true;
    }

    this.dataSourceTaxAdjustments = new MatTableDataSource(this.user.TaxAdjustments);
    this.dataSourceAttachmentOfSalary = new MatTableDataSource(this.user.AttachmentOfSalaries);
    this.CustomServiceFee = user.CustomServiceFee * 100;
    this.Commission = user.Commission * 100;
    this.setSelectedNotificationSettings();
    this.syncResolvedBankFromAccountDetails();
    this.setDefaultPensionSavingsSettings();
    this.ensurePayoutDayConsistency();
    Promise.resolve().then(() => {
      this.isLoading = false;
      this.changeDetectorRef.markForCheck();
    });

    if (this.user.MunicipalityIdPending > 0) {
      for (var i = 0; i < this.municipalities.length; i++) {
        if (this.municipalities[i].Id == this.user.MunicipalityIdPending) {
          this.pendingMunicipality = this.municipalities[i].Name;
        }
      }
    }

    if (this.user && this.user.ReferredByUserId) {
      const fullName = [user.ReferredByFirstName, user.ReferredByLastName]
        .filter(Boolean).join(' ').trim();
      const employmentNumber = user.ReferredByEmploymentNumber;
      this.referredByName = fullName || 'Uppgift om värvare saknas';
      if (employmentNumber != null) {
        this.referredByName += ` (${employmentNumber})`;
      }
    } else {
      this.referredByName = null;
    }

  }

  openReferrer() {
    if (!this.isAdmin || !this.user?.ReferredByUserId) {
      return;
    }

    this.dialog.open(UserEditComponent, {
      width: '1040px',
      maxWidth: 'calc(100vw - 48px)',
      height: 'calc(100vh - 48px)',
      maxHeight: 'calc(100vh - 48px)',
      panelClass: 'user-admin-dialog-panel',
      data: { userId: this.user.ReferredByUserId }
    });
  }

  setDefaultPensionSavingsSettings() {

    if (this.user.PensionSavingsSettings.PensionSavingsCompany == null) { 
      this.pensionSavingsCompanyChanged(3);
    }
    if (this.user.PensionSavingsSettings.Unit == null) {
      this.pensionSavingsTypeChanged(1);
    }
  }
    
  ngOnDestroy(): void {
  }

  updateCustomServiceFee() {

    if (this.user.HasCustomServiceFee) {
      this.user.CustomServiceFee = this.CustomServiceFee / 100;
    }
    else {
      this.user.CustomServiceFee = 0;
    }

  }

  updateCommission() {
        
    this.user.Commission = this.Commission / 100;
    
  }

  onUserError(response: any) {
    this.isLoading = false;
    const error = response?.error;
    const detail = typeof error === 'string' ? error : error?.ExceptionMessage || error?.message;
    const message = typeof detail === 'string'
      ? detail.split('\n')[0].replace(/^System\.Exception:\s*/i, '').trim()
      : '';
    this.validationErrorMessage = message || 'Ändringarna kunde inte sparas. Försök igen.';
    this.changeDetectorRef.detectChanges();
  }

  showMessage(message: string) {
      let config = new MatSnackBarConfig();
      config.duration = 7000;
      this.snackBar.open(message, undefined, config);
  }

  userUpdated(response: any) {
      //this.isLoading = false;
      if (this.isDialog && this.dialogRef) {
        this.dialogRef.close(response);
        return;
      }

      this.router.navigate(['/users']);
  }

  saveValidates() {
    this.bankValidationMessage = '';
    if (!this.user?.Country?.Id) {
      this.validationErrorMessage = "Du måste ange ett land";
      return false;
    }

    if (!this.user.Bank?.IsInternational && (this.user.ClearingNumber || this.user.AccountNumber)) {
      const bankValidationResult = this.swedishBankAccountValidationService.validate(
        this.banks,
        this.user.ClearingNumber,
        this.user.AccountNumber,
        this.user.PersonalNumber
      );

      if (!bankValidationResult.isValid) {
        this.bankValidationMessage = bankValidationResult.message;
        this.validationErrorMessage = bankValidationResult.message;
        return false;
      }

      if (bankValidationResult.resolvedBank) {
        this.user.Bank = JSON.parse(JSON.stringify(bankValidationResult.resolvedBank));
        this.user.BankName = bankValidationResult.resolvedBankName;
        this.user.ClearingNumber = bankValidationResult.normalizedClearingNumber;
        this.user.AccountNumber = bankValidationResult.normalizedAccountNumber;
      }
    }

    this.validationErrorMessage = '';
    return true;
  }

  editCustomer(customer: any) {
      this.router.navigate(['/customers', customer.Id]);
  }

  addTaxAdjustment(event?: Event) {
      
    this.config.data.taxAdjustment = null;

    let dialogRef = this.dialog.open(EditTaxAdjustmentDialogComponent, this.config);


    dialogRef.afterClosed().subscribe((result: ITaxAdjustment) => {

      if (result) {
          if (this.user.TaxAdjustments == null)
              this.user.TaxAdjustments = [];
          this.user.TaxAdjustments.push(result);
          this.refreshTaxAdjustmentsTable();
      }

      dialogRef = null;
    });
  }

  editTaxAdjustment(taxAdjustment: ITaxAdjustment) {
     
    if (taxAdjustment != null) {
        
      this.config.data.taxAdjustment = taxAdjustment;

      if (this.config.data.taxAdjustment.Attachment == null)
        this.config.data.taxAdjustment.Attachment = <IFile>
        {
          Id: 0, Guid: null, FileType: {}
        }
    }
    else {          
      this.config.data.taxAdjustment = {
        Id: this.newGuid(),
        Attachment: <IFile>{ Id: 0, Guid: null, FileType: {} }
      }
    }

    let dialogRef = this.dialog.open(EditTaxAdjustmentDialogComponent, this.config);

    dialogRef.afterClosed().subscribe((result: ITaxAdjustment) => {

      if (result != null) {
          for (var i = 0; i < this.user.TaxAdjustments.length; i++) {
              var d = this.user.TaxAdjustments[i];

            if (d.Guid == result.Guid || d.Id == result.Id)
            {
                  this.user.TaxAdjustments[i] = result;
                  this.refreshTaxAdjustmentsTable();
                  return;
            }                  
          }

          this.user.TaxAdjustments.push(result);
          this.refreshTaxAdjustmentsTable();
      }
            
      dialogRef = null;
    });
  }

  deleteTaxAdjustment(taxAdjustment: any) {
    var result = confirm("Vill du radera jämkningen?");
    if (result)
    {        
      for (var i = 0; i < this.user.TaxAdjustments.length; i++)
      {
        var d = this.user.TaxAdjustments[i];
        if (d.Guid == taxAdjustment.Guid)
        {
            this.user.TaxAdjustments.splice(i, 1);
            this.refreshTaxAdjustmentsTable();
            return;
        }
      }
    }
  }

  addAttachmentOfSalary(attachmentOfSalary: IAttachmentOfSalary) {
     
    this.config.data.attachmentOfSalary = null;

    let dialogRef = this.dialog.open(AttachmentOfSalaryDialogComponent, this.config);


    dialogRef.afterClosed().subscribe((result: IAttachmentOfSalary) => {
      
      if (result) {
        if (this.user.AttachmentOfSalaries == null)
          this.user.AttachmentOfSalaries = [];
        this.user.AttachmentOfSalaries.push(result);
        this.refreshAttachmentsTable();
      }

      dialogRef = null;
    });
  }

  editAttachmentOfSalary(attachmentOfSalary: IAttachmentOfSalary) {

    if (attachmentOfSalary != null) {
      
      this.config.data.attachmentOfSalary = attachmentOfSalary;

      if (this.config.data.attachmentOfSalary.Document == null)
        this.config.data.attachmentOfSalary.Document = <IFile>
          {
            Id: 0, Guid: null, FileType: {}
          }
    }
    else {
      this.config.data.attachmentOfSalary = {
        Id: this.newGuid(),
        Document: <IFile>{ Id: 0, Guid: null, FileType: {} }
      }
    }
        
    let dialogRef = this.dialog.open(AttachmentOfSalaryDialogComponent, this.config);

    dialogRef.afterClosed().subscribe((result: IAttachmentOfSalary) => {

        if (result != null) {
          for (var i = 0; i < this.user.AttachmentOfSalaries.length; i++) {
            var d = this.user.AttachmentOfSalaries[i];

          if (d.Guid == result.Guid || d.Id == result.Id) {
            this.user.AttachmentOfSalaries[i] = result;
            this.refreshAttachmentsTable();
            return;
          }
        }

        this.user.AttachmentOfSalaries.push(result);
        this.refreshAttachmentsTable();
      }

      dialogRef = null;
    });
  }

  deleteAttachmentOfSalary(attachmentOfSalary: any) {
    var result = confirm("Vill du radera utmätningen?");
    if (result) {
      for (var i = 0; i < this.user.AttachmentOfSalaries.length; i++) {
        var d = this.user.AttachmentOfSalaries[i];
        if (d.Guid == attachmentOfSalary.Guid) {
          this.user.AttachmentOfSalaries.splice(i, 1);
          this.refreshAttachmentsTable();
          return;
        }
      }
    }
  }

  pensionSavingsCompanyChanged(event: any) {

    if (this.user.PensionSavingsSettings.PensionSavingsCompany == null) {
      this.user.PensionSavingsSettings.PensionSavingsCompany = {Id: 0, Name: '', TechnicalName: ''};
    }

    if (event == 1) {
      this.user.PensionSavingsSettings.PensionSavingsCompany.Id = 1;
      this.user.PensionSavingsSettings.PensionSavingsCompany.TechnicalName = "SPP";
    }
    else if (event == 2) {
      this.user.PensionSavingsSettings.PensionSavingsCompany.Id = 2;
      this.user.PensionSavingsSettings.PensionSavingsCompany.TechnicalName = "Avanza";
    }
    else {
      this.user.PensionSavingsSettings.PensionSavingsCompany.Id = 3;
      this.user.PensionSavingsSettings.PensionSavingsCompany.TechnicalName = "NothingSelected";
    }
    
  }

  pensionSavingsTypeChanged(event: any) {

    if (event == 1) {
      this.user.PensionSavingsSettings.Unit.Id = 1;
      this.user.PensionSavingsSettings.Unit.TechnicalName = "Percent";
    }
    else {
      this.user.PensionSavingsSettings.Unit.Id = 2;
      this.user.PensionSavingsSettings.Unit.TechnicalName = "Share";
    }

  }

  changeValue(value) {
    this.user.HasCustomServiceFee = value.checked;
  }

  changeValueSuspended(value) {
    this.user.Suspended = value.checked;
  }

  changeFTaxValue(value) {
    this.user.FTax = value.checked;
  }

  changeCoordinationNumberValue(value) {
    this.user.HasCoordinationNumber = value.checked;
  }

  changeSampoolenEmployerValue(value) {
    this.user.SampoolenIsPrimaryEmployer = value.checked;
  }

  onPayoutTypeChange(newType: number) {
    if (!this.user) {
      return;
    }
    this.user.PayoutType = newType;
    this.ensurePayoutDayConsistency();
  }

  onPayoutDayChange(rawValue: any) {
    if (!this.user) {
      return;
    }
    const parsed = Number(rawValue);
    this.user.PayoutDay = isNaN(parsed) ? 0 : parsed;
    this.updatePayoutDayWarning();
  }

  private ensurePayoutDayConsistency() {
    if (!this.user) {
      return;
    }
    if (this.user.PayoutType === 1 || this.user.PayoutType == null) {
      this.user.PayoutDay = 0;
    }
    this.updatePayoutDayWarning();
  }

  private updatePayoutDayWarning() {
    if (!this.user) {
      return;
    }
    const payoutDay = Number(this.user.PayoutDay || 0);
    const needsWarning = this.user.PayoutType === 2 && (!payoutDay || payoutDay < 1 || payoutDay > 28);
    const payoutDayMessage = "Du måste ange en dag i månaden (1-28) när fast datum är valt.";
    if (needsWarning) {
      this.validationErrorMessage = payoutDayMessage;
    } else if (this.validationErrorMessage === payoutDayMessage) {
      this.validationErrorMessage = "";
    }
  }

  private refreshTaxAdjustmentsTable() {
    if (this.dataSourceTaxAdjustments) {
      this.dataSourceTaxAdjustments.data = [...this.user.TaxAdjustments];
    } else {
      this.dataSourceTaxAdjustments = new MatTableDataSource(this.user.TaxAdjustments);
    }
    this.changeDetectorRef.markForCheck();
  }

  private refreshAttachmentsTable() {
    if (this.dataSourceAttachmentOfSalary) {
      this.dataSourceAttachmentOfSalary.data = [...this.user.AttachmentOfSalaries];
    } else {
      this.dataSourceAttachmentOfSalary = new MatTableDataSource(this.user.AttachmentOfSalaries);
    }
    this.changeDetectorRef.markForCheck();
  }

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }

  showFile(file: IFile) {
    this.fileService.openFile(file);
  }

  onSubmit() {
    if (!this.saveValidates()) {
      return;
    }

    this.ensurePayoutDayConsistency();
    this.updateCustomServiceFee();
    this.updateCommission(); 

    this.user.ReferredCode = this.ReferredCode;
    
    this.isLoading = true;
    this.userService.updatetUser(this.user)
      .subscribe(
        res => this.userUpdated(res),
        err => this.onUserError(err),
        () => console.log('HTTP request completed.')
      );
  }

    
  config = {
    disableClose: false,
    panelClass: 'custom-overlay-pane-class',
    hasBackdrop: true,
    backdropClass: '',
    width: '500px',
    height: '95vh',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    },
    data: {
      userId: undefined,
      taxAdjustment: undefined,
      attachmentOfSalary: undefined
    },
    dataTemplate: {
      "Id": 0,
      "Type": {},
      "HoursWorked": undefined,
      "StartDate": undefined,
      "EndDate": undefined,
      "Comment": undefined,
      "InvoiceId": 0
    }
  };
}



